"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypesUI = void 0;
exports.TypesUI = {
    root: "ui.root",
    uiRootClass: "ui.root.class",
    setupAction: "ui.setupAction",
    startScreenAction: "ui.startScreenAction",
    endScreenAction: "ui.endScreenAction",
    events: {
        SCREEN_CHANGED: "UIEvents.SCREEN_CHANGED",
        POPUP: "UIEvents.POPUP",
        SHOW_CUSTOM_ALERT: "UIEvents.SHOW_CUSTOM_ALERT"
    },
    screen: {
        GAME_OVER: "ui.screen.GAME_OVER",
        HOME: "ui.screen.HOME",
        WIN: "ui.screen.WIN",
        SHOP: "ui.screen.SHOP",
        LEADERBOARD: "ui.screen.LEADERBOARD",
        GAMEPLAY: "ui.screen.GAMEPLAY"
    },
    customComponent: {
        SOCIAL_BANNERS: "ui.customComponent.SOCIAL_BANNERS"
    }
};
//# sourceMappingURL=TypesUI.js.map